import React from 'react'

import withCategory from '../hoc/with-category'

const MainMenu = ({categoryList, droppedMenuVisible, setDroppedMenuVisible, categoryId, setCategoryId}) => {

  const itemList = categoryList.map(({id, title}) => {
    const className = droppedMenuVisible && id === parseInt(categoryId) ? ' main-menu__item_active' : '';
    return (
      <li className={`main-menu__item main-menu__item_sales${className}`}
          key={id}>
        <a data-id={id} href="/">{title}</a>
      </li>
    )
  });

  const handleClick = event => {
    event.preventDefault();

    const newCategoryId = event.target.dataset.id;

    if (newCategoryId) {
      setCategoryId(newCategoryId);
      setDroppedMenuVisible(true);
    }

    if (newCategoryId === categoryId && droppedMenuVisible) {
      setDroppedMenuVisible(false);
    }
  };

  return (
    <nav className="main-menu">
      <div className="wrapper">
        <ul className="main-menu__items"
            onClick={handleClick}>
          {itemList}
        </ul>
      </div>
    </nav>
  )
};

export default withCategory(MainMenu)
